import React from "react";
import BotonRegresar from "./shared/BotonRegresar";

export default function Servicios({ onBack }) {
  const servicios = [
    {
      titulo: "ACOMPAÑAMIENTO PSICOLÓGICO",
      descripcion:
        "Atención psicológica y emocional  al paciente y sus familiares, enfocado al acompañamiento durante todo el tratamiento clínico de la enfermedad.",
      img: "/assets/images/servicios/psico.jpeg",
      color: "#ef7cab",
    },
    {
      titulo: "CENTRO DE CONOCIMIENTOS",
      descripcion:
        "Disminuir el rezago educativo de los pacientes y sus hermanos menores de edad, con el fin de fomentar la permanencia escolar y potenciar su futuro académico y laboral.",
      img: "/assets/images/servicios/centro.jpg",
      color: "#88aadd",
    },
    {
      titulo: "MEDICAMENTOS Y ESTUDIOS CLÍNICOS",
      descripcion:
        " Entrega de medicamentos de especialidad y apoyo para la realización de estudios clínicos.",
      img: "/assets/images/servicios/medicamentos.jpeg",
      color: "#ef7cab",
    },
    {
      titulo: "ATENCIÓN NUTRICIONAL",
      descripcion:
        "Atención nutricional a pacientes y sus familiares, para coadyuvar  en su tratamiento medico.",
      img: "/assets/images/servicios/nut.jpeg",
      color: "#ef7cab",
    },
    {
      titulo: "SEGURIDAD ALIMENTARIA",
      descripcion:
        "Entrega de alimentos para el paciente y su familia, con productos de la canasta básica y/o específicos.",
      img: "/assets/images/servicios/nutricional.jpeg",
      color: "#88aadd",
    },
    {
      titulo: "GESTIÓN SOCIAL",
      descripcion:
        "Satisfacer requerimientos clínicos y servicios asistenciales en base a las necesidades específicas del paciente y su tratamiento médico.",
      img: "/assets/images/servicios/gestion.jpg",
      color: "#ef7cab",
    },
  ];

  return (
    <div className="container" style={{ marginTop: "3rem", marginBottom: "4rem" }}>
      <div className="card" style={{ padding: "2rem", borderRadius: "20px" }}>
        <h4 className="center-align" style={{ color: "#ef7cab", marginBottom: "2rem" }}>
          Servicios 
        </h4>

        <div className="row">
          {servicios.map((s, i) => (
            <div className="col s12 m12 l4" key={i}>
              <div
                className="card servicio-card"
                style={{ backgroundColor: s.color }}
              >
                <div
                  style={{
                    position: "relative",
                    height: "406px",
                    backgroundImage: `url(${s.img})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      opacity: 0.2,
                    }}
                  />
            
                </div>
                <div
                  style={{
                    padding: "1rem",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "17px",
                    textAlign: "center",
                  }}
                >
                 <h6
                    style={{
                      // position: "absolute",
                      // bottom: "1rem",
                      marginBottom:"0.75rem",
                      width: "100%",
                      color: "white",
                      textAlign: "center",
                      fontWeight: "600",
                      // padding: "0 0.5rem",
                      zIndex: 2,
                      textShadow: "1px 1px 4px rgba(0,0,0,0.4)",
                    }}
                  >
                    {s.titulo}
                  </h6>
                  {s.descripcion}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="input-field center-align">
          <BotonRegresar onClick={onBack} />
        </div>
      </div>
    </div>
  );
}
